import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { QueryResult } from '../../stores/dataStore';
import { DropDownPillarsStore, PillarDto } from '../../stores/configuration/profiles/pillars-store';
import { SelectionInput } from '../form/selectionInput';
import { nameof } from '../../utils/object';
import { ItemReference } from '../../stores/dataStore';
import { isNullOrWhiteSpaces } from '../../utils/useful-functions';

interface PillarsEditorProps extends WithTranslation {
  value: ItemReference;
  onChange: (value: ItemReference) => void;
  className?: string;
  placeholder?: string;
  pillars?: DropDownPillarsStore;
  nullable?: boolean;
  minWidth?: number;
  reloadOnChange?: boolean;
  readonly?: boolean;
  clearable?: boolean;
}

interface PillarsEditorState {
  value: ItemReference;
  query?: (searchQuery: string) => Promise<QueryResult<ItemReference>>;
}

@connect(['pillars', DropDownPillarsStore])
class PillarsEditor extends React.Component<PillarsEditorProps, PillarsEditorState> {
  private get pillarsStore() {
    return this.props.pillars;
  }

  constructor(props: PillarsEditorProps) {
    super(props);
    this.state = {
      value: this.props.value,
      query: this.getPillarsMethod()
    };
  }

  UNSAFE_componentWillReceiveProps(next) {
    if (next !== this.props && next.value !== this.props.value && this.props.reloadOnChange) {
      this.setState({
        value: next.value,
        query: this.getPillarsMethod()
      });
    }
  }

  @autobind
  private getPillarsMethod() {
    const method = async (search: string) => {
      const result = await this.pillarsStore.getAllAsync(
        {
          searchQuery: '',
          skip: 0,
          take: 100000,
          orderBy: [{ direction: 'Ascending', field: nameof<PillarDto>('name'), useProfile: false }],
          filter: isNullOrWhiteSpaces(search) ? [] : [`startswith(tolower(${nameof<PillarDto>('name')}), '${search.toLowerCase()}')`]
        },
        null,
        search
      );
      return Object.assign({}, result, { items: result.items.map(c => ({ id: c.id, title: c.name })) }) as QueryResult<ItemReference>;
    };
    return method;
  }

  public render() {
    const val = this.state.value;
    const query = this.state.query;
    return (
      <SelectionInput
        content={item => <div>{item.title}</div>}
        searchable
        className={this.props.className}
        readOnly={this.props.readonly}
        minWidth={this.props.minWidth}
        nullable={this.props.nullable}
        placeholder={this.props.placeholder}
        query={query}
        value={val}
        onChange={value => this.props.onChange(value as any)}
        clearable={this.props.clearable}
      />
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(PillarsEditor);
